// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Botones globales que ya tenías ===== */
.Button {
  height: 38px !important;
}

.btn-primary-modals-permisos-roles {
  background-color: #006699;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-primary-modals-permisos-roles:hover {
  background-color: #005580;
}

.btn-primary-modals-permisos-roles[disabled],
.btn-primary-modals-permisos-roles:disabled {
  opacity: .6;
  cursor: not-allowed;
}

/* Botón compacto y elegante */
.btn--edit {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  padding: .35rem .75rem;
  font-size: .875rem;
  /* 14px aprox */
  line-height: 1;
  background: #006699;
  /* azul tipo primary */
  color: #fff;
  border: 1px solid #006699;
  border-radius: 9999px;
  /* pill */
  box-shadow: 0 2px 6px rgba(13, 110, 253, .25);
  cursor: pointer;
  transition: transform .12s ease, box-shadow .12s ease, background .12s ease;
}

.btn--edit:hover {
  background: #005580;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(13, 110, 253, .3);
}

.btn--edit:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(13, 110, 253, .25) inset;
}

.btn--edit:focus {
  outline: 2px solid transparent;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, .35);
}

.btn--edit .icon {
  font-size: 1rem;
  /* 16px */
  line-height: 0;
}


/* Variante XS */
.btn--edit.btn--xs {
  padding: .25rem .55rem;
  font-size: .8125rem;
  /* 13px */
}

/* ===== Específico del modal de Permisos por Rol (scope .mpr) ===== */
.mpr .mpr-header .input-group {
  min-width: 260px;
}

.mpr .mpr-card {
  border-radius: .75rem;
}

.mpr .mpr-badged {
  font-size: .75rem;
  opacity: .75;
}

/* Textarea de notas (móvil y/o donde se use) */
.mpr .mpr-note {
  width: 100%;
  min-height: 64px;
  resize: vertical;
  font-size: .875rem;
  line-height: 1.25rem;
}

/* Tabla desktop: mantener layout legible */
.mpr .table thead th,
.mpr .table tbody td {
  vertical-align: middle;
}

/* Columna "Notas" en desktop: ancho sugerido */
.mpr .table thead th.mpr-notes,
.mpr .table tbody td.mpr-notes {
  width: 400px;
  max-width: 440px;
  white-space: normal;
  word-break: break-word;
}

/* Checkbox header con indeterminate visual */
.mpr .form-check-input.indeterminate {
  position: relative;
}

.mpr .form-check-input.indeterminate::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 2px;
  background: currentColor;
  transform: translate(-50%, -50%);
}

/* Restituye el estilo de checkbox en este modal cuando otros CSS hacen \`all: unset\` global */
.mpr input[type="checkbox"].form-check-input {
  all: revert;
  width: 1em;
  height: 1em;
  margin-top: 0;
  vertical-align: middle;
  cursor: pointer;
}

/* Responsive: en móvil el botón Guardar va debajo del buscador en inline-block */
@media (max-width: 767.98px) {
  .mpr-modal .modal-header {
    display: contents;
  }

  .mpr-modal .modal-header > *:not(.btn-close) {
    display: block !important;
  }

  .mpr-modal .mpr-mobile-title {
    display: none !important;
  }

  .mpr-modal .modal-header .btn-close {
    position: absolute;
    top: 42px;
    right: 16px;
    z-index: 3;
    display: grid;
    width: 38px;
    height: 38px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background-color: #edf2f8;
    background-size: 14px;
    opacity: 1;
  }

  .mpr-modal .responsive-modal-sheet-close {
    display: none;
  }

  .mpr-modal .modal-content {
    display: flex;
    flex-direction: column;
    background: #f8faff;
    border: 0;
    border-radius: 28px 28px 0 0;
  }

  .mpr-modal .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    height: calc(min(82dvh, 760px) - 26px);
    max-height: calc(min(82dvh, 760px) - 26px) !important;
    padding: 0 12px 24px !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  /* En el estado expandido el cuerpo ocupa todo el espacio disponible,
     como el modal responsive de seguimiento. El scroll queda aquí y no en
     el contenedor que sostiene la X. */
  .mpr-modal.responsive-modal-sheet-expanded .modal-body {
    height: calc(100dvh - 26px);
    max-height: calc(100dvh - 26px) !important;
    min-height: calc(100dvh - 26px) !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .mpr-modal .responsive-modal-sheet-close {
    top: 42px;
    right: 16px;
    width: 38px;
    height: 38px;
    background: #edf2f8;
    color: #30445d;
    font-size: 27px;
  }

  .mpr {
    padding: 0 !important;
    color: #10213d;
  }

  .mpr-mobile-title {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 2px 52px 18px 4px;
  }

  .mpr-mobile-title-icon {
    display: grid;
    flex: 0 0 70px;
    width: 70px;
    height: 70px;
    border-radius: 22px;
    background: #e3efff;
    color: #1478f2;
    font-size: 39px;
    place-items: center;
  }

  .mpr-mobile-title h2 {
    margin: 0 0 5px;
    color: #14233d;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.08;
  }

  .mpr-mobile-title p {
    max-width: 290px;
    margin: 0;
    color: #657994;
    font-size: 15px;
    line-height: 1.3;
  }

  .mpr .mpr-header {
    gap: 12px;
    margin-bottom: 18px !important;
  }

  .mpr .mpr-header > h5 {
    display: none;
  }

  .mpr .mpr-search {
    width: 100%;
    height: 52px;
    overflow: hidden;
    border: 1px solid #dce5f0;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(30, 65, 110, .05);
  }

  .mpr .mpr-search .input-group-text {
    width: 58px;
    justify-content: center;
    border: 0;
    background: #fff;
    color: #7890aa;
    font-size: 24px;
  }

  .mpr .mpr-search .form-control {
    height: 50px !important;
    border: 0;
    box-shadow: none;
    color: #203754;
    font-size: 16px;
  }

  .mpr .mpr-search .form-control::placeholder {
    color: #9cacbf;
  }

  .mpr .mpr-save-desktop {
    display: none !important;
  }

  .mpr .mpr-save-mobile {
    display: inline-flex !important;
    align-items: center;
    width: 100% !important;
    justify-content: center !important;
    min-height: 54px;
    margin-top: 0 !important;
    border-radius: 17px;
    background: linear-gradient(110deg, #0876d1, #078ee1);
    box-shadow: 0 8px 18px rgba(12, 117, 211, .2);
    font-size: 17px;
    font-weight: 700;
    text-align: center !important;
    align-self: center !important;
    box-sizing: border-box !important;
  }

  .mpr-mobile-card {
    overflow: hidden;
    margin: 0 0 12px;
    padding: 0 !important;
    border: 0;
    border-radius: 24px;
    background: rgba(255, 255, 255, .94);
    box-shadow: 0 5px 18px rgba(39, 73, 116, .08);
  }

  .mpr-mobile-card-heading {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 13px;
    min-height: 88px;
    padding: 14px 18px;
    border: 0;
    background: transparent;
    color: inherit;
    text-align: left;
  }

  .mpr-mobile-card-icon {
    display: grid;
    flex: 0 0 58px;
    width: 58px;
    height: 58px;
    border-radius: 18px;
    background: #e5f0ff;
    color: #1676ef;
    font-size: 31px;
    place-items: center;
  }

  .mpr-mobile-card:nth-child(3n) .mpr-mobile-card-icon {
    background: #def8ed;
    color: #13a77d;
  }

  .mpr-mobile-card-title {
    display: flex;
    flex: 1 1;
    min-width: 0;
    flex-direction: column;
    gap: 3px;
  }

  .mpr-mobile-card-title strong {
    overflow: hidden;
    color: #162640;
    font-size: 20px;
    font-weight: 800;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mpr-mobile-card-title small {
    overflow: hidden;
    color: #657994;
    font-size: 14px;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mpr-mobile-card-chevron {
    display: grid;
    flex: 0 0 42px;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #f0f4f9;
    color: #334a66;
    font-size: 25px;
    place-items: center;
  }

  .mpr-mobile-card-body {
    position: relative;
    padding: 0 18px 18px;
  }

  .mpr-mobile-card-body .mpr-badged {
    display: block;
    margin: 0 0 5px;
    color: #273b59;
    font-size: 16px;
    font-weight: 700;
    opacity: 1;
  }

  .mpr .mpr-note {
    min-height: 110px;
    padding: 15px 16px 25px;
    border: 0;
    border-radius: 16px;
    background: #eef2f8;
    color: #536985;
    font-size: 16px;
    resize: none;
  }

  .mpr .mpr-note:disabled {
    opacity: 1;
  }

  .mpr-note-count {
    position: absolute;
    top: 91px;
    right: 29px;
    color: #72839b;
    font-size: 11px;
  }

  .mpr-permission-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin-top: 10px;
  }

  .mpr-permission-option {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    min-width: 0;
    min-height: 86px;
    padding: 12px 10px;
    border: 1px solid #f0f3f7;
    border-radius: 17px;
    background: #fbfcfe;
  }

  .mpr-permission-option .form-check-input {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    margin: 1px 0 0;
    border: 2px solid #a9b7c7;
    border-radius: 6px;
    accent-color: #1478f2;
  }

  .mpr-permission-copy {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 3px;
  }

  .mpr-permission-copy strong {
    color: #14233d;
    font-size: 16px;
    line-height: 1.1;
  }

  .mpr-permission-copy small {
    color: #71829a;
    font-size: 12px;
    line-height: 1.2;
  }
}

@media (max-width: 430px) {
  .mpr-mobile-title-icon {
    flex-basis: 58px;
    width: 58px;
    height: 58px;
    border-radius: 18px;
    font-size: 32px;
  }

  .mpr-mobile-title h2 { font-size: 21px; }
  .mpr-mobile-title p { font-size: 13px; }
  .mpr-mobile-card-title strong { font-size: 17px; }
  .mpr-mobile-card-title small { font-size: 12px; }
  .mpr-permission-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/modalPermisosRoles.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,6CAA6C;EAC7C,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;;AAGA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;;EAEE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;;EAEE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA,6FAA6F;AAC7F;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sCAAsC;IACtC,qDAAqD;IACrD,+BAA+B;IAC/B,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;;uCAEqC;EACrC;IACE,2BAA2B;IAC3B,0CAA0C;IAC1C,0CAA0C;IAC1C,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,qDAAqD;IACrD,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,oCAAoC;IACpC,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA,uBAAuB,eAAe,EAAE;EACxC,sBAAsB,eAAe,EAAE;EACvC,gCAAgC,eAAe,EAAE;EACjD,+BAA+B,eAAe,EAAE;EAChD,uBAAuB,gDAAgD,EAAE;AAC3E","sourcesContent":["/* ===== Botones globales que ya tenías ===== */\n.Button {\n  height: 38px !important;\n}\n\n.btn-primary-modals-permisos-roles {\n  background-color: #006699;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.btn-primary-modals-permisos-roles:hover {\n  background-color: #005580;\n}\n\n.btn-primary-modals-permisos-roles[disabled],\n.btn-primary-modals-permisos-roles:disabled {\n  opacity: .6;\n  cursor: not-allowed;\n}\n\n/* Botón compacto y elegante */\n.btn--edit {\n  display: inline-flex;\n  align-items: center;\n  gap: .5rem;\n  padding: .35rem .75rem;\n  font-size: .875rem;\n  /* 14px aprox */\n  line-height: 1;\n  background: #006699;\n  /* azul tipo primary */\n  color: #fff;\n  border: 1px solid #006699;\n  border-radius: 9999px;\n  /* pill */\n  box-shadow: 0 2px 6px rgba(13, 110, 253, .25);\n  cursor: pointer;\n  transition: transform .12s ease, box-shadow .12s ease, background .12s ease;\n}\n\n.btn--edit:hover {\n  background: #005580;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 14px rgba(13, 110, 253, .3);\n}\n\n.btn--edit:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(13, 110, 253, .25) inset;\n}\n\n.btn--edit:focus {\n  outline: 2px solid transparent;\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, .35);\n}\n\n.btn--edit .icon {\n  font-size: 1rem;\n  /* 16px */\n  line-height: 0;\n}\n\n\n/* Variante XS */\n.btn--edit.btn--xs {\n  padding: .25rem .55rem;\n  font-size: .8125rem;\n  /* 13px */\n}\n\n/* ===== Específico del modal de Permisos por Rol (scope .mpr) ===== */\n.mpr .mpr-header .input-group {\n  min-width: 260px;\n}\n\n.mpr .mpr-card {\n  border-radius: .75rem;\n}\n\n.mpr .mpr-badged {\n  font-size: .75rem;\n  opacity: .75;\n}\n\n/* Textarea de notas (móvil y/o donde se use) */\n.mpr .mpr-note {\n  width: 100%;\n  min-height: 64px;\n  resize: vertical;\n  font-size: .875rem;\n  line-height: 1.25rem;\n}\n\n/* Tabla desktop: mantener layout legible */\n.mpr .table thead th,\n.mpr .table tbody td {\n  vertical-align: middle;\n}\n\n/* Columna \"Notas\" en desktop: ancho sugerido */\n.mpr .table thead th.mpr-notes,\n.mpr .table tbody td.mpr-notes {\n  width: 400px;\n  max-width: 440px;\n  white-space: normal;\n  word-break: break-word;\n}\n\n/* Checkbox header con indeterminate visual */\n.mpr .form-check-input.indeterminate {\n  position: relative;\n}\n\n.mpr .form-check-input.indeterminate::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 2px;\n  background: currentColor;\n  transform: translate(-50%, -50%);\n}\n\n/* Restituye el estilo de checkbox en este modal cuando otros CSS hacen `all: unset` global */\n.mpr input[type=\"checkbox\"].form-check-input {\n  all: revert;\n  width: 1em;\n  height: 1em;\n  margin-top: 0;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n/* Responsive: en móvil el botón Guardar va debajo del buscador en inline-block */\n@media (max-width: 767.98px) {\n  .mpr-modal .modal-header {\n    display: contents;\n  }\n\n  .mpr-modal .modal-header > *:not(.btn-close) {\n    display: block !important;\n  }\n\n  .mpr-modal .mpr-mobile-title {\n    display: none !important;\n  }\n\n  .mpr-modal .modal-header .btn-close {\n    position: absolute;\n    top: 42px;\n    right: 16px;\n    z-index: 3;\n    display: grid;\n    width: 38px;\n    height: 38px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background-color: #edf2f8;\n    background-size: 14px;\n    opacity: 1;\n  }\n\n  .mpr-modal .responsive-modal-sheet-close {\n    display: none;\n  }\n\n  .mpr-modal .modal-content {\n    display: flex;\n    flex-direction: column;\n    background: #f8faff;\n    border: 0;\n    border-radius: 28px 28px 0 0;\n  }\n\n  .mpr-modal .modal-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    height: calc(min(82dvh, 760px) - 26px);\n    max-height: calc(min(82dvh, 760px) - 26px) !important;\n    padding: 0 12px 24px !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* En el estado expandido el cuerpo ocupa todo el espacio disponible,\n     como el modal responsive de seguimiento. El scroll queda aquí y no en\n     el contenedor que sostiene la X. */\n  .mpr-modal.responsive-modal-sheet-expanded .modal-body {\n    height: calc(100dvh - 26px);\n    max-height: calc(100dvh - 26px) !important;\n    min-height: calc(100dvh - 26px) !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .mpr-modal .responsive-modal-sheet-close {\n    top: 42px;\n    right: 16px;\n    width: 38px;\n    height: 38px;\n    background: #edf2f8;\n    color: #30445d;\n    font-size: 27px;\n  }\n\n  .mpr {\n    padding: 0 !important;\n    color: #10213d;\n  }\n\n  .mpr-mobile-title {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 2px 52px 18px 4px;\n  }\n\n  .mpr-mobile-title-icon {\n    display: grid;\n    flex: 0 0 70px;\n    width: 70px;\n    height: 70px;\n    border-radius: 22px;\n    background: #e3efff;\n    color: #1478f2;\n    font-size: 39px;\n    place-items: center;\n  }\n\n  .mpr-mobile-title h2 {\n    margin: 0 0 5px;\n    color: #14233d;\n    font-size: 24px;\n    font-weight: 800;\n    line-height: 1.08;\n  }\n\n  .mpr-mobile-title p {\n    max-width: 290px;\n    margin: 0;\n    color: #657994;\n    font-size: 15px;\n    line-height: 1.3;\n  }\n\n  .mpr .mpr-header {\n    gap: 12px;\n    margin-bottom: 18px !important;\n  }\n\n  .mpr .mpr-header > h5 {\n    display: none;\n  }\n\n  .mpr .mpr-search {\n    width: 100%;\n    height: 52px;\n    overflow: hidden;\n    border: 1px solid #dce5f0;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 3px 12px rgba(30, 65, 110, .05);\n  }\n\n  .mpr .mpr-search .input-group-text {\n    width: 58px;\n    justify-content: center;\n    border: 0;\n    background: #fff;\n    color: #7890aa;\n    font-size: 24px;\n  }\n\n  .mpr .mpr-search .form-control {\n    height: 50px !important;\n    border: 0;\n    box-shadow: none;\n    color: #203754;\n    font-size: 16px;\n  }\n\n  .mpr .mpr-search .form-control::placeholder {\n    color: #9cacbf;\n  }\n\n  .mpr .mpr-save-desktop {\n    display: none !important;\n  }\n\n  .mpr .mpr-save-mobile {\n    display: inline-flex !important;\n    align-items: center;\n    width: 100% !important;\n    justify-content: center !important;\n    min-height: 54px;\n    margin-top: 0 !important;\n    border-radius: 17px;\n    background: linear-gradient(110deg, #0876d1, #078ee1);\n    box-shadow: 0 8px 18px rgba(12, 117, 211, .2);\n    font-size: 17px;\n    font-weight: 700;\n    text-align: center !important;\n    align-self: center !important;\n    box-sizing: border-box !important;\n  }\n\n  .mpr-mobile-card {\n    overflow: hidden;\n    margin: 0 0 12px;\n    padding: 0 !important;\n    border: 0;\n    border-radius: 24px;\n    background: rgba(255, 255, 255, .94);\n    box-shadow: 0 5px 18px rgba(39, 73, 116, .08);\n  }\n\n  .mpr-mobile-card-heading {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 13px;\n    min-height: 88px;\n    padding: 14px 18px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n  }\n\n  .mpr-mobile-card-icon {\n    display: grid;\n    flex: 0 0 58px;\n    width: 58px;\n    height: 58px;\n    border-radius: 18px;\n    background: #e5f0ff;\n    color: #1676ef;\n    font-size: 31px;\n    place-items: center;\n  }\n\n  .mpr-mobile-card:nth-child(3n) .mpr-mobile-card-icon {\n    background: #def8ed;\n    color: #13a77d;\n  }\n\n  .mpr-mobile-card-title {\n    display: flex;\n    flex: 1;\n    min-width: 0;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  .mpr-mobile-card-title strong {\n    overflow: hidden;\n    color: #162640;\n    font-size: 20px;\n    font-weight: 800;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .mpr-mobile-card-title small {\n    overflow: hidden;\n    color: #657994;\n    font-size: 14px;\n    line-height: 1.25;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .mpr-mobile-card-chevron {\n    display: grid;\n    flex: 0 0 42px;\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    background: #f0f4f9;\n    color: #334a66;\n    font-size: 25px;\n    place-items: center;\n  }\n\n  .mpr-mobile-card-body {\n    position: relative;\n    padding: 0 18px 18px;\n  }\n\n  .mpr-mobile-card-body .mpr-badged {\n    display: block;\n    margin: 0 0 5px;\n    color: #273b59;\n    font-size: 16px;\n    font-weight: 700;\n    opacity: 1;\n  }\n\n  .mpr .mpr-note {\n    min-height: 110px;\n    padding: 15px 16px 25px;\n    border: 0;\n    border-radius: 16px;\n    background: #eef2f8;\n    color: #536985;\n    font-size: 16px;\n    resize: none;\n  }\n\n  .mpr .mpr-note:disabled {\n    opacity: 1;\n  }\n\n  .mpr-note-count {\n    position: absolute;\n    top: 91px;\n    right: 29px;\n    color: #72839b;\n    font-size: 11px;\n  }\n\n  .mpr-permission-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n    margin-top: 10px;\n  }\n\n  .mpr-permission-option {\n    display: flex;\n    align-items: flex-start;\n    gap: 9px;\n    min-width: 0;\n    min-height: 86px;\n    padding: 12px 10px;\n    border: 1px solid #f0f3f7;\n    border-radius: 17px;\n    background: #fbfcfe;\n  }\n\n  .mpr-permission-option .form-check-input {\n    flex: 0 0 24px;\n    width: 24px;\n    height: 24px;\n    margin: 1px 0 0;\n    border: 2px solid #a9b7c7;\n    border-radius: 6px;\n    accent-color: #1478f2;\n  }\n\n  .mpr-permission-copy {\n    display: flex;\n    min-width: 0;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  .mpr-permission-copy strong {\n    color: #14233d;\n    font-size: 16px;\n    line-height: 1.1;\n  }\n\n  .mpr-permission-copy small {\n    color: #71829a;\n    font-size: 12px;\n    line-height: 1.2;\n  }\n}\n\n@media (max-width: 430px) {\n  .mpr-mobile-title-icon {\n    flex-basis: 58px;\n    width: 58px;\n    height: 58px;\n    border-radius: 18px;\n    font-size: 32px;\n  }\n\n  .mpr-mobile-title h2 { font-size: 21px; }\n  .mpr-mobile-title p { font-size: 13px; }\n  .mpr-mobile-card-title strong { font-size: 17px; }\n  .mpr-mobile-card-title small { font-size: 12px; }\n  .mpr-permission-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
